import PropTypes from 'prop-types';
import { SplunkHttp } from '../components/_generic/axiosSplunk/axiosSplunk';
import Form404 from '../components/errors/Form404';
import { PAGE_ERROR_TITLE } from '../config/text/text';

function Error({ statusCode, errorResponse }) {
  const data = Object.assign(
    {},
    {
      error: true,
      error_message: JSON.stringify(
        errorResponse,
        Object.getOwnPropertyNames(errorResponse),
      ),
      statusCode,
    },
  );
  SplunkHttp(data);

  return (
    <>
      <Form404 statusCode={statusCode} />
    </>
  );
}

Error.getInitialProps = ({ res, err }) => {
  try {
    const errorResponse = res ? res : err;
    const statusCode = errorResponse.statusCode
      ? errorResponse.statusCode
      : 404;
    // We send the error to Splunk
    return { errorResponse, statusCode };
  } catch {
    return { errorResponse: {}, statusCode: '' };
  }
};

// Show page title
Error.title = PAGE_ERROR_TITLE;
// Show the counterdown timer
Error.countdown = false;

Error.propTypes = {
  statusCode: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

Error.defaultProps = {
  statusCode: '',
};

export default Error;
